export const DEFAULT_HOME_CONTENT = {
  hero_title: "مكتبة ARAN TOOLS للتوعية باستخدام الوسائط رقمياً",
  introduction: "تجد هنا شروحات حول الروابط والخصوصية وحقوق المحتوى. خدمات تحليل الروابط وتنزيل الوسائط متوقفة حالياً.",
  faq_title: "أسئلة شائعة",
  sections: [
    {
      id: "service-overview",
      kind: "text",
      title: "معلومات واضحة عن خدمات الموقع",
      paragraphs: ["تقدم ARAN TOOLS مكتبة تعليمية وصفحات إرشادية حول استخدام الوسائط الرقمية والخصوصية وحقوق أصحاب المحتوى. خدمات تحليل الروابط والتنزيل الآلي متوقفة حالياً حتى مراجعة الأذونات ومسارات الوصول لكل منصة."],
      visible: true,
      order: 10,
    },
    {
      id: "supported-platforms",
      kind: "platforms",
      title: "حالة أدوات المنصات",
      paragraphs: ["قد لا تظهر أدوات منصات في الوقت الحالي. لا يعني وجود رابط قديم أو صفحة مؤرشفة أن التحليل أو التنزيل متاح. استخدم الحفظ أو التصدير الرسمي الذي توفره المنصة."],
      visible: true,
      order: 20,
    },
    {
      id: "video-results",
      kind: "text",
      title: "الخصوصية وحقوق المحتوى",
      paragraphs: ["لا ترسل كلمات مرور أو رموز تحقق أو روابط خاصة إلى أدوات الموقع. احترم إعدادات الخصوصية وحقوق صاحب المحتوى وشروط المنصة، ولا تحفظ أو تعِد نشر مادة إلا إذا كان ذلك مسموحاً لك."],
      visible: true,
      order: 30,
    },
  ],
  faqs: [
    { id: "how-to-use", question: "ما الخدمات المتاحة حالياً؟", answer: "المكتبة التعليمية والصفحات الإرشادية متاحة للقراءة. خدمات تحليل الروابط وتنزيل الوسائط متوقفة حالياً.", visible: true, order: 10 },
    { id: "private-content", question: "هل ينبغي إرسال رابط خاص أو بيانات دخول؟", answer: "لا. لا ترسل روابط خاصة أو كلمات مرور أو رموز تحقق. لا يتجاوز الموقع إعدادات الخصوصية.", visible: true, order: 20 },
    { id: "formats-and-quality", question: "كيف أحفظ الوسائط من المنصة؟", answer: "استخدم أدوات الحفظ أو التصدير الرسمية التي توفرها المنصة نفسها، وتأكد من امتلاكك الحق أو الإذن المناسب.", visible: true, order: 30 },
    { id: "missing-option", question: "كيف أبلّغ عن محتوى أو مشكلة؟", answer: "استخدم قناة التواصل الموجودة في صفحة الاتصال، وأرسل رابط الصفحة وشرحاً واضحاً للطلب ومعلومات التواصل اللازمة لمراجعته.", visible: true, order: 40 },
    { id: "account-password", question: "هل أحتاج إلى إدخال كلمة مرور حسابي؟", answer: "لا. لا تطلب ARAN TOOLS كلمات المرور أو رموز التحقق. لا تشارك هذه البيانات في أي نموذج.", visible: true, order: 50 },
  ],
  seo_title: "",
  seo_description: "",
};
